import { ModelDetail } from "@/types/Intelligence";

/**
 * Utility to check if a model supports Confidential Inference (Secure AI mode)
 * @param model The model detail object
 * @returns boolean
 */
export const isConfidentialInferenceModel = (model?: ModelDetail | null): boolean => {
  if (!model) return false;

  return model.supportsAttestation ?? false;
};

/**
 * Utility to check if a model ID corresponds to a Confidential Inference model
 * @param modelId The ID of the model
 * @param models The list of all models from the store
 * @returns boolean
 */
export const isConfidentialInferenceId = (
  modelId: string | undefined,
  models: ModelDetail[]
): boolean => {
  if (!modelId) return false;

  const model = models.find((m) => m.id === modelId);
  if (model) {
    return isConfidentialInferenceModel(model);
  }

  // Fallback: check the ID string itself if model details aren't loaded yet
  return modelId.toLowerCase().includes("kimi-k2");
};

/**
 * Generates a 32-digit hexadecimal nonce (128 bits)
 * @returns string
 */
export const generate32DigitHexNonce = (): string => {
  const array = new Uint8Array(16);
  window.crypto.getRandomValues(array);
  return Array.from(array, (byte) => byte.toString(16).padStart(2, "0")).join("");
};
